import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import WalletSectionCard from './WalletSectionCard';
import WalletCountryWorkProfilePhoto from '../wallet/WalletCountryWorkProfilePhoto';
import { authorizedToWorkStatus } from '../../reducers/countryWorkProfile';
import usWorkCardStyle from '../../style/components/profile/USWorkSectionCard.module.scss';

const WalletWorkAuthorizationSummary = () => {
  const { t } = useTranslation();
  const { authorizedToWork, immigrationStatus } = useSelector(
    (state) => state.countryWorkProfile,
  );
  const status = authorizedToWorkStatus(authorizedToWork);

  return (
    <WalletSectionCard className={usWorkCardStyle.card}>
      <div className={usWorkCardStyle.summaryContent}>
        <WalletCountryWorkProfilePhoto
          alt=""
          className={usWorkCardStyle.summaryPhoto}
        />
        <div>
          <p className={usWorkCardStyle.summaryLine}>
            {status === 'yes' && t('profile.authorizedInUS')}
            {status === 'no' && t('profile.notAuthorizedInUS')}
            {status === 'unknown' && t('profile.unknownAuthorizationInUS')}
          </p>
          <p className={usWorkCardStyle.summaryLine}>
            {immigrationStatus ? t(`profile.basis.${immigrationStatus}`) : ''}
          </p>
        </div>
      </div>
    </WalletSectionCard>
  );
};

export default memo(WalletWorkAuthorizationSummary);
